import Api from "..";
import { TransmedRegistrationContestationAnswerInput, TransmedRegistrationContestationAskInput } from "../../dtos/transmed/process/registration/contestation";
import { PublicTransmedRegistration } from "../../dtos/transmed/process/registration/registration";
import transform from "../../service/transform";

export default class TransmedContestationApi extends Api {
  constructor() {
    super("transmed/registration/contestation");
  }

  public async get(): Promise<PublicTransmedRegistration[]> {
    const data = (await super.get()).data;
    if (!Array.isArray(data))
      throw new TypeError(
        "OutputTransmedRegistrationPart entry list is not an array."
      );

    return await Promise.all(
      data.map(
        async (value) => await transform(PublicTransmedRegistration)(value)
      )
    );
  }

  public async post(
    data: TransmedRegistrationContestationAskInput
  ): Promise<void> {
    return await super.post(data);
  }

  public async put(
    id: string,
    data: TransmedRegistrationContestationAnswerInput
  ): Promise<void> {
    return await super.put(id, data);
  }
}
